<div class="container login">
    <div class="row">
        <div class="col-md-8 offset-md-2">
            <div class="box mt40 mb40 static">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="static-content">
                            <h2 class="tac"><span class="font-normal">{{productNames[id-1]}}</span>ÜCRETSİZ DEMO TALEP
                                ET</h2>
                            <section id="demotalepet" class="section-padding">
                                <form [formGroup]="contactForm">
                                    <div class="row">
                                        <div class="col-md-12" *ngIf="!formValid">
                                            <div class="form-horizontal">
                                                <div class="form-group row">
                                                    <label class="control-label col-sm-2" for="email">Şirket *</label>
                                                    <div class="col-sm-10" *ngIf="!formValid">
                                                        <input type="text" class="form-control"
                                                            formControlName="company">
                                                    </div>
                                                </div>
                                                <div class="form-group" *ngIf="!companyValid" class="text-danger">
                                                    Şirket bilgisi boş geçilemez.
                                                </div>
                                                <div class="form-group row">
                                                    <label class="control-label col-sm-2" for="pwd">Adı *</label>
                                                    <div class="col-sm-10" *ngIf="!formValid">
                                                        <input type="text" class="form-control" formControlName="name">
                                                    </div>
                                                </div>
                                                <div class="form-group" *ngIf="!nameValid" class="text-danger">
                                                    Ad bilgisi boş geçilemez.
                                                </div>
                                                <div class="form-group row">
                                                    <label class="control-label col-sm-2" for="pwd">Soyadı *</label>
                                                    <div class="col-sm-10" *ngIf="!formValid">
                                                        <input type="text" class="form-control"
                                                            formControlName="surName">
                                                    </div>
                                                </div>
                                                <div class="form-group" *ngIf="!surNameValid" class="text-danger">
                                                    Soyad bilgisi boş geçilemez.
                                                </div>
                                                <div class="form-group row">
                                                    <label class="control-label col-sm-2" for="pwd">E-posta *</label>
                                                    <div class="col-sm-10" *ngIf="!formValid">
                                                        <input type="text" class="form-control" formControlName="email">
                                                    </div>
                                                </div>
                                                <div class="form-group" *ngIf="!mailValid" class="text-danger">
                                                    E-posta bilgisi boş geçilemez.
                                                </div>
                                                <div class="form-group row">
                                                    <label class="control-label col-sm-2" for="pwd">Telefon *</label>
                                                    <div class="col-sm-10" *ngIf="!formValid">
                                                        <input class="form-control" type="text" prefix="+90"
                                                            mask="(000) 000 00 00" formControlName="phone"
                                                            (ngModelChange)="checkPhone()">
                                                    </div>
                                                </div>
                                                <div class="form-group" *ngIf="!phoneValid" class="text-danger">
                                                    Telefon bilgisi kontrol ediniz.
                                                </div>
                                                <div class="form-group row">
                                                    <label class="control-label col-sm-2" for="pwd">Mesaj</label>
                                                    <div class="col-sm-10" *ngIf="!formValid">
                                                        <textarea class="form-control" data-rule-required="true"
                                                            id="Message" name="Message"
                                                            formControlName="message"></textarea>
                                                    </div>
                                                </div>
                                                <div class="form-group row">
                                                    <div class="col-sm-12 tar" *ngIf="!formValid">
                                                        <button type="submit" class="btn btn-primary"
                                                            (click)="onSubmit()">Gönder</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12" *ngIf="formValid">
                                            <div class="table-responsive">
                                                <div class="alert alert-success">Bilgileriniz bize ulaşmıştır.</div>
                                                <table class="table table-bordered">
                                                    <tbody>
                                                        <tr>
                                                            <td><b>Şirket</b></td>
                                                            <td>{{this.contactForm.value.company}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Adı</b></td>
                                                            <td>{{this.contactForm.value.name}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Soyad</b></td>
                                                            <td>{{this.contactForm.value.surName}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>E-posta</b></td>
                                                            <td>{{this.contactForm.value.email}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Telefon</b></td>
                                                            <td>{{this.contactForm.value.phone}}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><b>Mesaj</b></td>
                                                            <td>{{this.contactForm.value.message}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>